module.exports = __webpack_public_path__ + "static/media/box.371db6df.png";